// extracted by mini-css-extract-plugin
module.exports = {"button":"Applicants_button__1fkib"};